var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--freemium_banner freemium-banner tw-shadow tw-h-[75px] tw-w-full tw-rounded tw-py-[15px] tw-px-5 tw-relative tw-cursor-pointer tw-content-center tw-flex tw-items-center",
    attrs: {
      "data-testid": "freemium-banner"
    },
    on: {
      "click": _vm.openFreemiumModal
    }
  }, [_c('div', {
    staticClass: "tw-w-full tw-flex tw-justify-between tw-items-center ltr:tw-pl-[110px] rtl:tw-pr-[110px]"
  }, [_c('div', {
    staticClass: "heading tw-text-primary tw-text-14 lg:tw-text-4 tw-font-semibold tw-leading-6"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('components.freemium.how-to-get-free-esim')) + "\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "airalo-icon-arrow-right tw-text-primary"
  })]), _vm._v(" "), _c('HowFreemiumWorks', {
    attrs: {
      "view-modal": _vm.modalOpen
    },
    on: {
      "onClose": _vm.closeFreemiumModal
    }
  }), _vm._v(" "), _c('FreemiumIncompatible', {
    attrs: {
      "view-modal": _vm.incompatibleModalOpen
    },
    on: {
      "onClose": _vm.closeFreemiumModal
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }